// loanSettlement

import {
  Box,
  Button,
  Card,
  Divider,
  Group,
  Menu,
  rem,
  Stack,
  Text,
} from "@mantine/core";
import { IconChevronDown, IconCreditCard } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toCurrency } from "utils/common";
import { LoanPending } from "./LoanPending";
import { LoanCompleted, LoanDetailInfo } from "./StepLoanCompleted";
import test from "assets/images/pngs/test1.png";
import { LoanSettlementDetail } from "./LoanSettlementDetail";
import OTpCode from "components/modal/otp-code/OtpCode";
import { useDisclosure } from "@mantine/hooks";

const InfoItemSettlement = ({
  label,
  value,
  bold = false,
  boldLabel = false,
  blue = false,
}: {
  label: string;
  value: string;
  bold?: boolean;
  boldLabel?: boolean;
  blue?: boolean;
}) => (
  <Group align="start" spacing={8}>
    <Text fw={boldLabel ? 700 : 400} color="#6D6D6D" fz={16} miw={160}>
      {label}
    </Text>
    <Text fw={bold ? 700 : 400} color={blue ? "#0E74DA" : ""} fz={14}>
      {value}
    </Text>
  </Group>
);

export const LoanSettlement = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [opened, { open: OpenOTPCode, close: CloseOTPCode }] =
    useDisclosure(false);
  // const dataSections = [
  //   {
  //     title: t("REQUEST_INFORMATION"),
  //     data: [
  //       { label: t("TRANSACTION_TYPE"), value: t("SETTLEMENT"), bold: true },
  //       { label: t("LOAN_ACCOUNT"), value: "DF330035253231" },
  //       { label: t("LOAN_ACCOUNT"), value: "029847571234" },
  //     ],
  //   },
  //   {
  //     title: t("REQUEST_INFORMATION"),
  //     data: [
  //       {
  //         label: t("OUTSTANDING_PRINCIPAL"),
  //         value: `${toCurrency(100000000)} VND`,
  //       },
  //       {
  //         label: t("ACCRUED_INTEREST"),
  //         value: `${toCurrency(12000)} VND`,
  //       },
  //       {
  //         label: t("OVERDUE_PRINCIPAL"),
  //         value: `${toCurrency(0)} VND`,
  //       },
  //       {
  //         label: t("LATE_PAYMENT_INTEREST"),
  //         value: `${toCurrency(0)} VND`,
  //       },
  //       {
  //         label: t("LATE_PAYMENT_FEE"),
  //         value: `${toCurrency(0)} VND`,
  //       },
  //       {
  //         label: t("EARLY_REPAYMENT_FEE"),
  //         value: `${toCurrency(0)} VND`,
  //       },
  //       {
  //         label: t("TOTAL_SETTLEMENT_AMOUNT"),
  //         value: `${toCurrency(100012000)} VND`,
  //         blue: true,
  //       },
  //     ],
  //   },
  // ];
  const data1 = [
    {
      label: t("LOAN_ACCOUNT"),
      value: "DF330035253231",
      bold: true,
    },
    { label: t("PRODUCT"), value: t("CONSUMER_LOANS"), bold: true },
    { label: t("MATURITY_DATE"), value: "27/01/2025", bold: true },
    {
      label: t("OUTSTANDING_PRINCIPAL"),
      value: `${toCurrency(105000000)} VND`,
      bold: true,
      blue: true,
    },
  ];

  const data2 = [
    {
      label: t("OUTSTANDING_PRINCIPAL"),
      value: `${toCurrency(100000000)} VND`,
      bold: true,
    },
    {
      label: t("ACCRUED_INTEREST"),
      value: `${toCurrency(12000)} VND`,
      bold: true,
    },
    {
      label: t("OVERDUE_PRINCIPAL"),
      value: `${toCurrency(0)} VND`,
      bold: true,
    },
    {
      label: t("OVERDUE_INTEREST"),
      value: `${toCurrency(0)} VND`,
      bold: true,
    },
    {
      label: t("LATE_PAYMENT_INTEREST"),
      value: `${toCurrency(0)} VND`,
      bold: true,
    },
    {
      label: t("LATE_PAYMENT_FEE"),
      value: `${toCurrency(0)} VND`,
      bold: true,
    },
    {
      label: t("EARLY_REPAYMENT_FEE"),
      value: `${toCurrency(0)} VND`,
      bold: true,
    },
    {
      label: t("TOTAL_SETTLEMENT_AMOUNT"),
      value: `${toCurrency(100012000)} VND`,
      bold: true,
      blue: true,
      boldLabel: true,
    },
  ];
  // const handleSubmit = () => {
  //   setStep("step2"); // Chuyển sang bước hiển thị <LoanSettlementDetail />
  // };
  const nextStep = () => setStep((prev) => Math.min(prev + 1, 2));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 0));

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <>
            <LoanSettlementDetail
              onNext={() => OpenOTPCode()}
              onCancel={prevStep}
            />
            <OTpCode
              opened={opened}
              close={CloseOTPCode}
              setShowSuccessModal={nextStep}
            />
          </>
        );

      case 2:
        return (
          <LoanPending
            goBack={prevStep}
            form={
              <LoanCompleted
                title={t("ORDER_CREATED_SUCCESSFULLY_AND_WAITING_FOR_APPROVAL")}
                amount={toCurrency(100012000)}
                img={test}
                form={
                  <LoanDetailInfo
                    details={[
                      {
                        label: t("TRANSACTION_TYPE"),
                        content: "LOAN_SETTLEMENT",
                      },
                      {
                        label: t("TRANSACTION_DATE"),
                        content: "27/03/2025",
                      },
                      {
                        label: t("LOAN_ACCOUNT"),
                        content: "029847571234",
                      },
                      {
                        label: t("OUTSTANDING_PRINCIPAL"),
                        content: `${toCurrency(100000000)} VND`,
                      },
                      {
                        label: t("ACCRUED_INTEREST"),
                        content: `${toCurrency(12000)} VND`,
                      },
                      {
                        label: t("OVERDUE_PRINCIPAL"),
                        content: `${toCurrency(0)} VND`,
                      },
                      {
                        label: t("LATE_PAYMENT_INTEREST"),
                        content: `${toCurrency(0)} VND`,
                      },
                      {
                        label: t("LATE_PAYMENT_FEE"),
                        content: `${toCurrency(0)} VND`,
                      },
                      {
                        label: t("EARLY_REPAYMENT_FEE"),
                        content: `${toCurrency(0)} VND`,
                      },
                    ]}
                  />
                }
                addNew={() => {
                  setStep(0);
                }}
              />
            }
          />
        );
      case 0:
      default:
        return (
          <Box>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                borderLeft: "3px solid #246CF9",
                paddingLeft: "10px",
                margin: "20px 0",
              }}
            >
              <Text fw={600} size="24px">
                {t("LOAN_SETTLEMENT")}
              </Text>
            </Box>
            <Box w={929}>
              <Card.Section inheritPadding py="xs">
                <Text fz="lg" weight={600}>
                  {t("SOURCE_ACCOUNT")}
                </Text>
              </Card.Section>
              <Card.Section
                inheritPadding
                p="xs"
                pt={0}
                pb="md"
                className="prt-formacc-card"
              >
                <Menu shadow="md" width="100%">
                  <Menu.Target>
                    <Box>
                      <Group className="prt-formacc-group">
                        <Box
                          sx={{
                            background: "#FDFDFD",
                            padding: "8px",
                            borderRadius: "50%",
                          }}
                        >
                          <IconCreditCard />
                        </Box>
                        <div style={{ flex: 1 }}>
                          <Text
                            size="md"
                            weight={500}
                            className="prt-total-balanceAmount"
                            style={{ color: "#fff" }}
                          >
                            666613112001
                          </Text>
                          <Text
                            size="sm"
                            weight={400}
                            c="dimmed"
                            style={{ color: "#fff" }}
                          >
                            {t("TECHNOLOGY_JOINT_STOCK_COMPANY")} Proton
                          </Text>
                        </div>
                        <Text size="md" weight={500} color="#FFFFFF">
                          500,000,000 VND
                        </Text>
                        <IconChevronDown
                          size="0.9rem"
                          stroke={1.5}
                          style={{ color: "white" }}
                        />
                      </Group>
                    </Box>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box>
                          <Text weight={700} size={16}>
                            666613112001
                          </Text>
                          <Text color="#5E656B">
                            {t("TECHNOLOGY_JOINT_STOCK_COMPANY")} Proton
                          </Text>
                        </Box>
                        <Box
                          style={{
                            color: "#5E656B",
                            fontWeight: 700,
                          }}
                        >
                          500,000,000 VND
                        </Box>
                      </Box>
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Card.Section>
            </Box>
            <Card
              w={929}
              shadow="sm"
              radius="md"
              sx={{
                flex: "1",
              }}
            >
              <Stack spacing={24}>
                <Text fw={600} fz={20}>
                  {t("LOAN")}
                </Text>

                {data1.map((item, index) => (
                  <InfoItemSettlement {...item} />
                ))}
                <Divider />
                <Text fw={600} fz={20}>
                  {t("PAYMENT_INFORMATION")}
                </Text>

                {data2.map((item, index) => (
                  <InfoItemSettlement {...item} />
                ))}
              </Stack>
            </Card>

            {/* Footer luôn ở cuối */}
            <Group position="center" mt={rem(20)}>
              <Box
                style={{
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  width: "calc(100% - var(--mantine-navbar-width, 0px))",
                  padding: "10px 16px",
                  display: "flex",
                  justifyContent: "right",
                  gap: "10px",
                  boxShadow: "0px 5px 15px 0px #00000026",
                  height: "76px",
                  alignItems: "center",
                  backgroundColor: "white",
                  zIndex: 1,
                }}
              >
                <Button
                  sx={() => ({
                    width: "160px",
                    background: "#F4F4F6",
                    borderRadius: "8px",
                    padding: "8px 10px",
                    cursor: "pointer",
                    fontWeight: 600,
                    color: "black",
                    ":hover": {
                      background: "#F4F4F6",
                      color: "black",
                    },
                  })}
                  mr="xs"
                  type="reset"
                  // onClick={(e) => {
                  //   e.preventDefault();
                  // }}
                  onClick={prevStep}
                  disabled={step === 0}
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  sx={() => ({
                    width: "160px",
                    color: "white",
                    borderRadius: "8px",
                    padding: "8px 10px",
                    cursor: "pointer",
                    fontWeight: 400,
                    ":hover": {
                      color: "white",
                    },
                    background: "#2A81D0",
                  })}
                  type="submit"
                  onClick={nextStep}
                >
                  {t("NEXT")}
                </Button>
              </Box>
            </Group>
          </Box>
        );
    }
  };
  return <Box>{renderStepContent()}</Box>;
};
